import {PREDICTION_WIDGET} from "../predictions-widget.consts";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {PredictionsWidgetController} from "../predictions-widget.controller";
import {MarketNavigationClickEvent} from "../../../core/models/events/market-navigation-click-event";
import {APP} from "../../../core/app/consts";
import {PredictionsWidgetState} from "../models/predictions-widget.state";

export class PredictionsWidgetMarketNavigationClickEventHandler extends AnalyticsEventHandler {
  type: PREDICTION_WIDGET.ACTION_TYPES = PREDICTION_WIDGET.ACTION_TYPES.marketNavigationClick;
  controller: PredictionsWidgetController;
  state: PredictionsWidgetState;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = MarketNavigationClickEvent;
  }

  async action(params) {
    const currentContext = this.state.currentContext;
    const nextMarketType: String = currentContext.cards[params.index]?.type;
    const clickDirection: String = currentContext.currentIndex < params.index ? APP.ANALYTICS.DIRECTIONS.RIGHT : APP.ANALYTICS.DIRECTIONS.LEFT

    const sendParams = {
      nextMarketType,
      clickDirection,
      ...params
    }

    const clickEvent: MarketNavigationClickEvent = new this.eventType(sendParams);
    await this.analyticsService.createEvent(clickEvent);
    currentContext.currentIndex = params.index
  }
}
